import { render, staticRenderFns } from "./HosipitalAssetRelatedAssets.vue?vue&type=template&id=2f714c3b&scoped=true"
import script from "./HosipitalAssetRelatedAssets.vue?vue&type=script&lang=js"
export * from "./HosipitalAssetRelatedAssets.vue?vue&type=script&lang=js"
import style0 from "./HosipitalAssetRelatedAssets.vue?vue&type=style&index=0&id=2f714c3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f714c3b",
  null
  
)

export default component.exports